import { createPaginatedSlice } from "../../../helpers/reduxHelper";

const myRenderPreview = createPaginatedSlice('myRenderPreview', {
  defaultState: {
    myRenderPreviewData: {},
    updateJsonModalData: null,
  },
  reducers: {
    setMyRenderPreviewData: (state, { payload }) => {
      state.myRenderPreviewData = payload;
    },
    setUpdateJsonModalData: (state, { payload }) => {
      state.updateJsonModalData = payload;
    }
  }
});

export const { setMyRenderPreviewData, setUpdateJsonModalData } = myRenderPreview.actions;
export const myRenderPreviewActions = myRenderPreview.actions
export const myRenderPreviewSelector = state => state.myRenderPreview;
export const selectUpdateJsonModalData = state => state.myRenderPreview.updateJsonModalData;
export const myRenderPreviewReducer = myRenderPreview.reducer;
export default myRenderPreviewReducer

export const myRenderPreviewSelectors = myRenderPreview.LF.selectors